<template>
  <span class="data-grid-group-cell-text">
    <el-tooltip v-if="cellIcon"
                :content="renderActionText"
                placement="top"
                effect="light"
                :enterable="false">
      <i :class="cellIcon"></i>
    </el-tooltip>
    <span v-else>
      <i v-if="renderActionIcon" :class="renderActionIcon"></i><span>{{renderActionText}}</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'DataGridGroupCellText',
  props: {
    config: {
      type: Object,
      required: true
    },
    renderAction: {
      type: Object,
      required: true
    },
    renderActionText: {
      type: String,
      required: true
    },
    renderActionIcon: String
  },
  computed: {
    actionIcon: function () {
      let config = this.config
      if (config.actionType) {
        let actionIcon
        switch (config.actionType) {
          case 'ADD':
            actionIcon = 'iconfont icon-add'
            break
          case 'EDIT':
            actionIcon = 'iconfont icon-edit'
            break
          case 'DELETE':
            actionIcon = 'iconfont icon-delete'
            break
          case 'IMPORT':
            actionIcon = 'iconfont icon-import'
            break
          case 'EXPORT':
            actionIcon = 'iconfont icon-export'
            break
          case 'PRINT':
            actionIcon = 'iconfont icon-printer'
            break
          case 'MARK':
            actionIcon = 'iconfont icon-tag'
            break
          case 'VIEW':
            actionIcon = 'iconfont icon-inquire'
            break
          case 'CLOCK':
            actionIcon = 'iconfont icon-clock'
            break
          case 'GRANT':
            actionIcon = 'iconfont icon-not-pass'
            break
          case 'ACCOUNT':
            actionIcon = 'iconfont icon-account-only'
            break
          case 'TOOL':
            actionIcon = 'iconfont icon-briefcase'
            break
          default:
            actionIcon = config.actionType
            break
        }
        return actionIcon
      }
    },
    cellIcon: function () {
      let config = this.config
      if (config && config.icon) {
        return config.icon
      }
      return this.actionIcon
    }
  }
}
</script>

<style lang="scss">
  .data-grid-group-cell-text {
    i {
      width: 24px;
      font-size: 14px;
    }
  }
</style>
